<script>
    import { onMount, afterUpdate } from 'svelte'
    import marked from 'marked'
    import page from 'page'

	export let entry;
	export let notebook;
    export let callback;


    // Format the content with links (and eventually markdown)
    let hover_content
    let content
    afterUpdate(() => {
        function label_refs(text) {
            let mapping = notebook.names_to_id
            const sorted_names = Object.keys(mapping).sort(
                (a, b) => b.length - a.length
            )
            for (const name of sorted_names) {
                const id = mapping[name]
                if (name == entry.name || entry.aliases.includes(name)) {
                    continue
                }

                function replacer(match, p1, p2, p3, offset, str, groups) {
                    if (p1.endsWith(">") | p3.startsWith("<")) {
                        return match
                    }
                    return `${p1}<a class="dynamic-link" data-entry="${id}">${p2}</a>${p3}`
                }

                const regex = new RegExp(`([\\W_])(${name})([\\W_])`, 'g')
                text = text.replace(
                    regex,
                    replacer
                    //`$1<a class="dynamic-link" data-entry="${id}">$2</a>$3`
                )
            }
            return text
        }
        content.innerHTML = marked(label_refs(entry.description))

        // Add hover handlers to show preview box
        let tags = document.getElementsByClassName('dynamic-link')
        for (var i = 0 ; i < tags.length ; i++) {
            let tag = tags[i]
            if (tag.hasAttribute('data-entry')) {
                tag.addEventListener("mouseover", e => {
                    var target = notebook.entries[tag.dataset['entry']]
                    hover_content.innerHTML = marked(`# ${target.name}\n\n` + target.description)
                    hover_content.style.display = "initial"
                    hover_content.style.position = "fixed"
                    hover_content.style.top = `${e.clientY + 20}px`
                    hover_content.style.left = `${e.clientX + 10}px`
                })
                tag.addEventListener("mouseout", e => {
                    hover_content.style.display = "none"
                })
                tag.addEventListener("click", e => {
                    callback(tag.dataset['entry'])
                })
            }
        }
    })
</script>

<div class="entry">
    <h1>
        {entry.name}
        <small>({entry.category})</small>
    </h1>

    <section bind:this={content}></section>
    <div id="hoverContent" bind:this={hover_content}></div>
</div>


<style>
small {
    color: gray;
}
section, div#hoverContent {
    text-align: left;
}

div#hoverContent {
    position: absolute;
    max-width: 300px;
    max-height: 500px;
    background: gray;
    padding: 0px 20px;
    overflow: hidden;
}
</style>
